<template>
  <EditRowForm
    :gridId="gridId"
    :rowKey="rowKey"
  />
</template>

<script>
// components
import EditRowForm from './forms/EditRow'

export default {
  props: {
    gridId: {
      type: String,
      required: true
    },
    rowKey: {
      type: String,
      required: true
    }
  },
  components: {
    EditRowForm
  }
}
</script>
